import { render, staticRenderFns } from "./BotonProcesoTabCaptura.vue?vue&type=template&id=f98c05a2&"
import script from "./BotonProcesoTabCaptura.vue?vue&type=script&lang=js&"
export * from "./BotonProcesoTabCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports